import type {ColumnsSetting, FeGridSettings} from '../types/Api';
import {isVirtualPresetEqual} from './isVirtualPresetEqual';

type CustomPresetSnapshot = {
  columnsSettings: ColumnsSetting[];
  gridSettings: FeGridSettings;
  queryId: string;
};

/**
 * Compares a saved custom preset snapshot against the current grid state.
 *
 * Returns `true` if the user has made unsaved changes (columns, settings, or filters/sort).
 *
 * - Columns + settings: delegates to `isVirtualPresetEqual` with a dummy `dataQueryId: ''`
 *   so the dataQueryId leg always passes; only column/settings differences are detected.
 * - Filters/sort (captured via queryId): dirty when `saved.queryId !== current.queryId`
 */
export function isCustomPresetDirty(
  saved: CustomPresetSnapshot,
  current: CustomPresetSnapshot
): boolean {
  if (saved.queryId !== current.queryId) {
    return true;
  }

  return !isVirtualPresetEqual(
    {columnsSettings: saved.columnsSettings, gridSettings: saved.gridSettings, dataQueryId: ''},
    {columnsSettings: current.columnsSettings, gridSettings: current.gridSettings, dataQueryId: ''}
  );
}
